module.exports = __webpack_public_path__ + "static/sport/form-bg.a880c94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/form/form-bg.png
// module id = PfoZ
// module chunks = 0